import React from 'react';
import Riachuelo from 'assets/icons/riachuelo-small.svg';

export const Footer: React.FC = () => (
  <div className="flex bg-black p-6 justify-between">
    <span className="text-white">Riachuelo © 2023</span>
    <img src={Riachuelo} alt="logo Riachuelo" />
  </div>
);
